import apis from '../../utils/apis';
import { AppDispatch } from '../index';
import { setGuidancePausedLocal } from '../../utils/tourGuidance';

export const loadTourCompletions = (completions: Record<string, string>) => ({
  type: 'LOAD_TOUR_COMPLETIONS' as const,
  payload: completions,
});

export const completeTour = (tourId: string) => async (dispatch: AppDispatch) => {
  try {
    const response = await apis.post('/tour-status/complete', { tour_id: tourId });
    if (response.data.success) {
      dispatch({
        type: 'TOUR_COMPLETED' as const,
        payload: { tourId, completions: response.data.tour_completions },
      });
    }
  } catch {
    // Non-critical — tour will just show again next time
  }
};

export const resetTourCompletion = (tourId: string) => async (dispatch: AppDispatch) => {
  try {
    const response = await apis.post('/tour-status/reset', { tour_id: tourId });
    if (response.data.success) {
      dispatch({
        type: 'TOUR_RESET' as const,
        payload: { tourId, completions: response.data.tour_completions },
      });
    }
  } catch {
    // Non-critical
  }
};

export const resetAllTours = () => async (dispatch: AppDispatch) => {
  try {
    const response = await apis.post('/tour-status/reset-all');
    if (response.data.success) {
      dispatch({ type: 'TOURS_RESET_ALL' as const });
    }
  } catch {
    // Non-critical
  }
};

/**
 * Enable/disable global product guidance (auto-starting feature tours).
 * Applies locally first (instant), then persists to the backend.
 */
export const setGuidanceEnabled = (enabled: boolean) => async (dispatch: AppDispatch) => {
  setGuidancePausedLocal(!enabled);
  dispatch({ type: 'SET_GUIDANCE' as const, payload: enabled });
  try {
    const response = await apis.post('/tour-status/guidance', { enabled });
    if (response.data.success) {
      dispatch({ type: 'LOAD_TOUR_COMPLETIONS' as const, payload: response.data.tour_completions });
    }
  } catch {
    // Non-critical — the local preference is already applied
  }
};
